import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { Session } from '../types/auth';

export function useAuth() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) {
        setSession({
          user: data.session.user ? { id: data.session.user.id, email: data.session.user.email } : null,
          access_token: data.session.access_token,
          refresh_token: data.session.refresh_token,
        });
      }
    }).catch(console.error).finally(() => setLoading(false));

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, s) => {
      (async () => {
        if (s) {
          setSession({
            user: s.user ? { id: s.user.id, email: s.user.email } : null,
            access_token: s.access_token,
            refresh_token: s.refresh_token,
          });
        } else {
          setSession(null);
        }
      })();
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return {
    session,
    loading,
    isAuthenticated: !!session?.user,
    user: session?.user || null,
  };
}
